//# sourceMappingURL=my-default-month.interface.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/mydatepicker/dist/interfaces/my-default-month.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-default-month.interface.js
// module chunks = 4